import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import vuetify from './plugins/vuetify'
import  VueCookies  from 'vue-cookies'
import '@/assets/css/estilos.scss'
import '@/assets/css/colores.scss'
import 'devextreme/dist/css/dx.light.css'
import esMessages from 'devextreme/localization/messages/es.json';
import { locale, loadMessages } from 'devextreme/localization';
import { rutas } from './Herramientas/rutas'
import i18n from './lang/vuei18n'
import constantes from './Herramientas/constantes'

Vue.prototype.$constantes = constantes

loadMessages(esMessages);
locale(navigator.language)

Vue.config.productionTip = false
Vue.use(VueCookies)
window.$rutas = rutas

const app = new Vue({
  router,
  i18n,
  store,
  vuetify,
  render: h => h(App)
}).$mount('#app')

Object.defineProperty(Vue.prototype, '$locale', {
  get: function () {
    return app.$i18n.locale
  },
  set: function (locale) {
    app.$i18n.locale = locale
  }
})
